export default function (value) {
  return value
    .replace(/\b\w/g, l => l.toUpperCase())
    .replace('IOS', 'iOS')
    .replace('.Js', '.js')
    .replace(' On ', ' on ');
}